import { createApi } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl.jsx";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const productDrawbackApi = createApi({
  reducerPath: "productDrawbackApi",
  baseQuery,
  tagTypes: ["Drawback","Drawer"],
  
  endpoints: (builder) => ({
    getProductDrawbackById: builder.query({
      query: (exportProductId) => `/export/product/drawback/${exportProductId}`,
      transformResponse: (response) => response?.data ?? [],
      providesTags: ["Drawback"],
    }),

    createDrawback: builder.mutation({
      query: ({ exportProductId, drawback }) => ({
        url: `/export/product/drawback/${exportProductId}`,
        method: "PUT", // ✅ add this
        body: { drawback },
      }),
      invalidatesTags: ["Drawback"],
    }),
  }),
});

export const {
  useCreateDrawbackMutation,
  useGetProductDrawbackByIdQuery,
} = productDrawbackApi;